import { useContext } from 'react'

import AppContext from '@/common/context/app.context'

import usePerformanceInsightsEarnings from './hooks/usePerformanceInsightsEarnings/usePerformanceInsightsEarnings'
import NetSalesToMarginCard from './NetSalesToMarginCard/NetSalesToMarginCard'
import YourEarningsCard from './YourEarningsCard/YourEarningsCard'

const EarningsSection = ({ periodParams }) => {
  const { info } = useContext(AppContext)
  const { earnings, fetchingEarnings, earningsError } = usePerformanceInsightsEarnings({
    storeId: info.selectedStore.id,
    startDate: periodParams.start_date,
    endDate: periodParams.end_date,
  })

  return (
    <>
      <YourEarningsCard earnings={earnings} loading={fetchingEarnings} error={earningsError} />
      <NetSalesToMarginCard earnings={earnings} loading={fetchingEarnings} error={earningsError} />
    </>
  )
}

export default EarningsSection
